/** @jsx jsx */
import { Fragment } from 'react'
import { Box, jsx } from 'theme-ui'
import useNotificationSaleBar from '~/hooks/components/use-notification-sale-bar'

const NotificationSaleBar = ({ isPageSpecific = false, pageNotification }) => {
  const { loaded, notification } = useNotificationSaleBar()
  let displayNotification = notification

  if (isPageSpecific) {
    displayNotification = pageNotification
  }

  if (!displayNotification?.slug) return <Fragment />

  return (
    <Box bg="brandSecondary">
      <Box
        sx={{
          '& p, & a': {
            alignItems: 'center',
            color: 'white',
            display: 'flex',
            fontSize: '14px',
            fontWeight: 'medium',
            letterSpacing: '0.6px',
            justifyContent: 'center',
            minHeight: '40px',
            m: 0,
            opacity: loaded ? '1' : '0',
            width: '100%',
          },
          '& a': {
            overflow: 'hidden',
            position: 'relative',
            textDecoration: 'none',
            '&:focus, &:hover': {
              textDecoration: 'underline',
            },
          },
          '& span': {
            animation: ['scroll-left 8s linear infinite', 'none'],
            transform: ['translateX(100%)', 'none'],
            whiteSpace: 'nowrap',
            '@keyframes scroll-left': {
              '0%': {
                transform: 'translateX(100%)',
              },
              '100%': {
                transform: 'translateX(-100%)',
              },
            },
            '@media screen and (prefers-reduced-motion: reduce)': {
              animation: 'none',
            },
          },
        }}
        dangerouslySetInnerHTML={{
          __html: displayNotification.description.childMarkdownRemark.html,
        }}
      />
    </Box>
  )
}

export default NotificationSaleBar
